module.exports = __webpack_public_path__ + "img/equal.6489b270.svg";